var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAllOrdersIcon = function SvgAllOrdersIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6D7278",
    d: "M6.573 4.609l1.194-.5c.146-.061.31-.061.456 0l1.194.5V.019H6.573v4.59z",
    transform: "translate(8 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#604325",
    d: "M15.99 14.56c0 .799-.65 1.449-1.449 1.449H1.448C.65 16.009 0 15.359 0 14.56V1.467C0 .67.65.02 1.448.02h3.946v5.476c0 .197.098.381.263.49.025.017.05.032.078.045.017.008.034.014.05.02l-.05-.02c.027.012.056.023.084.031l-.034-.01c.025.008.05.015.076.02l-.042-.01c.033.01.066.016.1.02l-.058-.01c.028.007.057.01.085.012l-.028-.002c.064.007.13.004.194-.01l.008-.003.09-.03 1.785-.746 1.784.747.09.029.013.003c.054.012.108.016.162.012l.027-.002-.027.002c.029-.002.058-.006.087-.012l-.06.01c.033-.004.065-.01.097-.02l-.037.01c.026-.005.05-.013.075-.021l-.038.012c.058-.017.114-.042.165-.076.164-.11.263-.294.263-.491V.019h3.945c.799 0 1.449.65 1.449 1.448V14.56z",
    transform: "translate(8 8)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAllOrdersIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/all_orders_icon.7dfd06a3.svg";
export { ForwardRef as ReactComponent };